<template>
  <div class="container mescroll-touch">
    <div class="navigationBar">
      <div class="nav-left">
        <img @click="goback" src="@/assets/images/back_icon.png" />
      </div>
      <div class="nav-title">我的专辑</div>
      <div class="nav-right"></div>
    </div>
    <div class="details">
      <div class="albumCount">
        <img src="@/assets/images/album_icon.png" />
        <span>共{{ list.length }}个专辑</span>
      </div>
      <div class="listBox" id="toTop">
        <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" id="dataList">
          <div class="list">
            <div class="listItem" v-for="(item, index) in list" :key="index" @click="toAlbumDetails(item.Id)">
              <div class="albumCover">
                <img class="cover" :src="item.Url" />
                <img class="cornerMark" src="@/assets/images/album_cornerMark.png" />
              </div>
              <div class="albumTitle van-multi-ellipsis--l2">{{ item.Name }}</div>
            </div>
          </div>
        </mescroll-vue>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import { mapState } from "vuex";
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  name: 'AlbumList',
  data() {
    return {
      hasPath: '',
      userId: '',
      list: [],
      PageIndex: 0,
      PageSize: 6,
      Total: 0,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 10 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_icon.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        },
        scrollTop: 0, // 记录离开页面时的滚动位置，用于返回时恢复
			}
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  computed: {
    ...mapState(["userInfo"]),
    sourceType() {
      return this.$route.query.sourceType
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == '/') {
        vm.hasPath = from.path;
      }
    });
  },
  created() {
    if(this.$route.query.uid) {
      this.userId = this.$route.query.uid;
    } else {
      this.userId = this.userInfo.Id;
    }

    wx.miniProgram.postMessage({
      data: {
        share: {
          title: '我的专辑',
          imageUrl: '',
          path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/albumList?uid=${this.$route.query.uid}&sourceType=7`)}`,
          contentId: ''
        }
      }
    })

    this.BuriedPoint(6, '我的专辑', '', `/albumList?uid=${this.$route.query.uid}`, this.$route.query.uid, '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
  },
  activated() {
    if(this.scrollTop > 0 && this.$refs.mescroll) {
      this.$refs.mescroll.$el.scrollTop = this.scrollTop;
    }
  },
  methods: {
    mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      this.$refs.mescroll.$el.addEventListener('scroll', () => {
        this.scrollTop = this.$refs.mescroll.$el.scrollTop
      })
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Album/GetAlbumAll', {
          UserId: this.userId,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then(res => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr)
          this.$forceUpdate()
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        })
      }, 200);
    },
    toAlbumDetails(id) {
      this.$router.push({
        path: 'albumDetails',
        query: {
          id: id
        }
      });
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push({
          path: 'Personal',
          query: {
            id: this.$route.query.uid
          }
        });
        return;
      }
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F9F8F7;
}
.navigationBar {
  display: flex;
  align-items: center;
  height: 52px;
  box-sizing: border-box;
  background-color: #EB1700;
  color: #FFFFFF;
  padding: 0 15px;
  .nav-left {
    img {
      display: block;
      width: 9px;
    }
  }
  .nav-title {
    flex: 1;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .nav-right {
    width: 9px;
  }
}
.details {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  .albumCount {
    display: flex;
    align-items: center;
    height: 20px;
    font-size: 12px;
    color: #000000;
    margin: 16px;
    img {
      display: block;
      width: 20px;
      margin-right: 4px;
    }
  }
  .listBox {
    position: relative;
    flex: 1;
    height: 0;
  }
  .mescroll {
    padding: 0 16px;
    box-sizing: border-box;
  }
  .list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    .listItem {
      .albumCover {
        position: relative;
        .cover {
          display: block;
          width: 100%;
          border-radius: 8px;
        }
        .cornerMark {
          position: absolute;
          top: 0;
          right: 8px;
          width: 25px;
        }
      }
      .albumTitle {
        height: 34px;
        line-height: 18px;
        font-size: 12px;
        color: #3D3D3D;
        margin: 8px 2px 0;
      }
    }
  }
}
</style>